import { createFileRoute } from '@tanstack/react-router';
import { RentalPhotosPage } from '@/features/rentals/pages/rental-photos-page';
import { requireRentalShop } from '@/lib/rental-guard';

export const Route = createFileRoute('/_app/rentals_/photos')({
  beforeLoad: requireRentalShop,
  component: RentalPhotosPage,
});
